<template lang="html">
  <div class="container">

    <div class="header">
     
      <p class="select">
        <!-- <span class="area">{{region_list[region[0]]}}</span> -->
        <span class="area">{{c_region[0]=='0'?'全部':getCurrentRegion()}}</span>
        <span class="time">&nbsp{{begin_time}}-{{end_time}}</span>
        <!-- <img src="../assets/img/avatar.jpg" alt="" @click="filter"> -->
        <i class="icon iconfont icon-shaixuan" @click="filter"></i>
      </p>

    </div>

    <ul class="field-wrappwe">

      <li class="field-item" @click="toDrill(2)">
        <p class="item-value"> <span class="symbol">¥</span> {{ data.hasBackMoney == undefined ? '' : (data.hasBackMoney/10000).toFixed(2) }}<span class="unit">(万)</span></p>
        <p class="item-name">已回款</p>
      </li>

      <li class="field-item" @click="toDrill(1)">
        <p class="item-value"> <span class="symbol">¥</span> {{ data.hasTotalMoney == undefined ? '' : (data.hasTotalMoney/10000).toFixed(2) }} <span class="unit">(万)</span></p>
        <p class="item-name">已签约 <span class="num">{{ data.hasCount == undefined ? '' : data.hasCount }}个</span></p>
      </li>

    </ul>

    <div class="data">
      <ul>
        <li @click="toDrill(3)">
          <!-- <span class="left">已制作完成待回款</span> -->
          <span class="left">已交付待回款</span>
          <span class="right">¥{{ data.hasOkWaitMoney == undefined ? '' : (data.hasOkWaitMoney/10000).toFixed(2)}}(万元)</span>
        </li>


        <li @click="toDrill(4)">
          <span class="left">已签约待回款</span>
          <span class="right">¥{{ data.hasContractWaitMoney == undefined ? '' : (data.hasContractWaitMoney/10000).toFixed(2) }}(万元)</span>
        </li>


        <li @click="toDrill(5)">
          <span class="left">已开票待回款</span>
          <span class="right">¥{{ data.hasInvoiceWaitMoney == undefined ? '' : (data.hasInvoiceWaitMoney/10000).toFixed(2)}}(万元)</span>
        </li>
      </ul>




      <p class="btn" @click="toMore">项目签约明细</p>
    </div>

    <div>
      <div class="rank">

        <p class="test">
         各区域签约金额占比(万)
        </p>
        <IEcharts   :option="pie1" @click="showDetail($event,1)"></IEcharts>

      </div>

      <div class="percent1">
        <p class="test">
          各区域回款金额占比(万)
        </p>
        <IEcharts :option="pie2" @click="showDetail($event,2)"></IEcharts>
      </div>

      <div class="percent2">
        <p class="test">
          各区域签约项目数占比(个)
        </p>
        <IEcharts :option="pie3" @click="showDetail($event,3)"></IEcharts>
      </div>
    </div>

    <div class="aler-list">
      <p class="test">回款预警项目</p>


      <div class="list-wrapper">

        <div class="list-item" v-for=" item in alertData">

          <div class="row text">
            <span> <span class="title">逾期时间</span>{{ Number(item.seconds).toFixed(0)  }}天</span>
            <span>制作一部</span>
          </div>

          <div class="row text">
            <span><span class="title">最后开票时间</span>{{ item.last_billed == null ? '未开票' : item.last_billed }}</span>
            <span>制作中</span>
          </div>

          <div class="row text">
            <span><span class="title">{{ item.first_party }}</span> {{ item.p_name }}</span>
            <span><span class="title">负责人</span>{{ item.sales }}</span>
          </div>

          <div class="row">

            <div class="row-item">
              <p class="item-value"> <span class="symbol">¥</span> {{ (item.b_money/10000).toFixed(2) }} <span class="unit">(万)</span></p>
              <p class="item-name">已回款金额</p>
            </div>

            <div class="row-item center">
              <p class="item-value"> <span class="symbol">¥</span> {{ (item.p_money/10000).toFixed(2) }} <span class="unit">(万)</span></p>
              <p class="item-name">项目金额</p>
            </div>

            <div class="row-item">
              <p class="item-value"> <span class="symbol">¥</span> {{ (item.y_no_money/10000).toFixed(2) }} <span class="unit">(万)</span> </p>
              <p class="item-name">已开发票待回款</p>
            </div>



          </div>
        </div>
      </div>

    </div>



    <div class="zhezhao" v-if="isFilter" @click="cancel"></div>

    <!--筛选-->
    <div class="selbox" v-if="isFilter">
      <p>筛选</p>

      <p class="content">
        时间
      </p>

      <ul class="listtime">
        <mt-picker :slots="slots" @change="onDateChange" valueKey="name" class="inner-picker" :visibleItemCount="3"></mt-picker>
      </ul>

      <p  class="content">
        区域
      </p>
      <!-- <ul  class="listtime">
        <li :class="{'true': index == c_region[0]}" v-for="(item,index) in region_list" @click="onRegionChang(index)" >{{item}}</li>
      </ul> -->
       <ul  class="listtime" >
        <li :class="{'true': item.id == c_region[0]}" v-for="(item,index) in region_list" @click="onRegionChang(item.id)" >{{item.name}}</li>
      </ul>


      <p class="btnyes" @click="confirmFilter">确定</p>
    </div>

  </div>
</template>

<script>
import config from '../fetch/config'
import IEcharts from 'vue-echarts-v3/src/lite.js'
import 'echarts/lib/component/legend'
import 'echarts/lib/chart/bar'
// import 'echarts/lib/chart/line'
import 'echarts/lib/component/title'
import 'echarts/lib/component/markPoint'
// import 'echarts/lib/component/markLine'

import '../assets/css/drillStyle.css'
import slotsList from '../assets/js/slotsList'
import { Popup, Picker } from 'mint-ui'

import dateChange from '../mixins/dateChange.js'
import regionChange from '../mixins/regionChange.js'
import { getMonthRanges } from '../assets/js/date'

export default {
  mixins: [dateChange, regionChange],
  components: {
    IEcharts
  },
  data() {
    return {
      isFilter: false,

      begin_time: '', //过滤时间

      end_time: '', //过滤时间

      region: [0], //过滤地区

      slots: slotsList.Monthslots(), //日期选择


      data: [], //主要数据
      alertData: [], // 预警数据
      pie1: {
        // color: ['#6DB0FB','#EC7A8A','#FAE35A','#D185FF','#FFA761','#FFA761'],
        tooltip: {
          trigger: 'axis'
        },
        title: [{
          text: '签约总金额',
          x: '49%',
          y: '32%',
          textAlign: 'center',
          textStyle: {
            color: '#333',
            fontSize: '12',
            fontWeight: '400',
          }
        },
        {
          text: '',
          x: '49%',
          y: '38%',
          textAlign: 'center',
          textStyle: {
            color: '#333',
            fontSize: '12',
            fontWeight: '400',
          }
        }],
        legend: {
          width: '60%',
          // right:'1%',
          // top:'5%',
          // height:'10%',
          bottom: '7%',
          icon: 'circle',
          //  data: ['北京', '上海','深圳','珠海','海南','成都','渠道'],
          data: [],
          itemGap: 20,
          textStyle: {
            fontSize: 12,
            color: '#333',
          }
        },
        series: [{
          center: ['50%', '37%'],
          color: ['#6DB0FB', '#EC7A8A', '#5CA03E', '#D185FF', '#FFA761', '#86E687'],
          hoverAnimation: false, //设置饼图默认的展开样式
          radius: [40, 60],
          name: 'pie',
          type: 'pie',
          selectedMode: 'single',
          selectedOffset: 6, //选中是扇区偏移量
          clockwise: true,
          startAngle: 90,
          //  data:[],
          data: [{ value: 100, name: '北京' }, { value: 200, name: '上海' }, { value: 150, name: '深圳' }, { value: 200, name: '珠海' }, { value: 100, name: '三亚' }, { value: 100, name: '成都' }],
          label: {
            normal: {
              show: true,
              position: 'outside',
              formatter: function (res) {
                return `${res.percent}% \n ${res.name}  ${(res.value / 10000).toFixed(2)}万`
              },
              textStyle: {
                fontSize: 10,
              }
            }
          }
        }]
      },
      pie2: {
        // color: ['#6DB0FB','#EC7A8A','#FAE35A','#D185FF','#FFA761','#FFA761'],
        tooltip: {
          trigger: 'axis'
        },
        title: [{
          text: '回款总金额',
          x: '49%',
          y: '32%',
          textAlign: 'center',
          textStyle: {
            color: '#333',
            fontSize: '12',
            fontWeight: '400',
          }
        },
        {
          text: '',
          x: '49%',
          y: '38%',
          textAlign: 'center',
          textStyle: {
            color: '#333',
            fontSize: '12',
            fontWeight: '400',
          }
        }],
        legend: {
          width: '60%',
          // right:'1%',
          // top:'5%',
          // height:'10%',
          bottom: '7%',
          icon: 'circle',
          data: [],
          // data: ['北京', '上海', '深圳', '珠海', '海南', '成都', '渠道'],

          itemGap: 20,
          textStyle: {
            fontSize: 12,
            color: '#333',
          }
        },
        series: [{
          center: ['50%', '37%'],
          color: ['#6DB0FB', '#EC7A8A', '#5CA03E', '#D185FF', '#FFA761', '#86E687'],
          hoverAnimation: false, //设置饼图默认的展开样式
          radius: [40, 60],
          name: 'pie',
          type: 'pie',
          selectedMode: 'single',
          selectedOffset: 6, //选中是扇区偏移量
          clockwise: true,
          startAngle: 90,
          data: [],
          // data: [{ value: 100, name: '北京' }, { value: 200, name: '上海' }, { value: 150, name: '深圳' }, { value: 200, name: '珠海' }, { value: 100, name: '三亚' }, { value: 100, name: '成都' }],
          label: {
            normal: {
              show: true,
              position: 'outside',
              formatter: function (res) {
                return `${res.percent}% \n ${res.name}  ${(res.value / 10000).toFixed(2)}万`
              },
              textStyle: {
                fontSize: 10,
              }
            }
          }
        }]
      },
      pie3: {
        // color: ['#6DB0FB','#EC7A8A','#FAE35A','#D185FF','#FFA761','#FFA761'],
        tooltip: {
          trigger: 'axis'
        },
        title: [{
          text: '签约项目数',
          x: '49%',
          y: '32%',
          textAlign: 'center',
          textStyle: {
            color: '#333',
            fontSize: '12',
            fontWeight: '400',
          }
        },
        {
          text: '',
          x: '49%',
          y: '38%',
          textAlign: 'center',
          textStyle: {
            color: '#333',
            fontSize: '12',
            fontWeight: '400',
          }
        }],
        legend: {
          width: '60%',
          // right:'1%',
          // top:'5%',
          // height:'10%',
          bottom: '7%',
          icon: 'circle',
          data: [],
          // data: ['北京', '上海', '深圳', '珠海', '海南', '成都', '渠道'],
          itemGap: 20,
          textStyle: {
            fontSize: 12,
            color: '#333',
          }
        },
        series: [{
          center: ['50%', '37%'],
          color: ['#6DB0FB', '#EC7A8A', '#5CA03E', '#D185FF', '#FFA761', '#86E687'],
          hoverAnimation: false, //设置饼图默认的展开样式
          radius: [40, 60],
          name: 'pie',
          type: 'pie',
          selectedMode: 'single',
          selectedOffset: 6, //选中是扇区偏移量
          clockwise: true,
          startAngle: 90,
          data: [],
          label: {
            normal: {
              show: true,
              position: 'outside',
              formatter: function (res) {
                return `${res.percent}% \n ${res.name}  ${res.value}`
              },
              textStyle: {
                fontSize: 12,
              }
            }
          }
        }]
      },
    }
  },
  methods: {
    filter() { //显示过滤
      this.slots = slotsList.Monthslots(this.begin_time, this.end_time)
      this.isFilter = true
      this.$emit('inFilter')
    },

    confirmFilter() { //确定过滤
      this.begin_time = this.c_begin_time
      this.end_time = this.c_end_time
      this.region = this.c_region
      let data = {
        begin_time: this.begin_time,
        end_time: this.end_time,
        region: this.region
      }
      this.isFilter = false
      this.$notice.loading()
      this.getData(data)
      this.$emit('noFilter')
    },

    cancel() { //点击阴影取消
      this.c_region = this.region
      this.isFilter = false
      this.$emit('noFilter')
    },

    toMore() { //明细数据
      this.$router.push({ name: 'analyze' })
      let data = {
        begin_time: this.begin_time,
        end_time: this.end_time,
        region: this.region
      }
      window.localStorage.setItem('drillData', JSON.stringify(data))
    },

    toDrill(type) { //数字钻取
      let data = {
        begin_time: this.begin_time,
        end_time: this.end_time,
        region: this.region
      }
      switch (type) {
        case 1:
          this.toSignDrill(data, type)
          break;
        case 2:
          this.toSignDrill(data, type)
          break;
        default:
          this.toSomeDrill(data, type)
          break;
      }
    },

    showDetail(event, type) { // echarts =》 钻取页
      let data = {
        begin_time: this.begin_time,
        end_time: this.end_time,
        origin_region: this.region,
        region: [],
      }
      data.region.push(this.findRegionID(event.name))
      console.log(event.name)
      // console.log(data.region)
      // 1:签约金额占比
      switch (type) {
        case 1:
          this.toSignDrill(data, type)
          break;
        case 2:
          this.toSignDrill(data, type)
          break;
        case 3:
          this.toSignDrill(data, 1)
          break;
        default:
      }
      // this.
    },

    toSignDrill(data, type) { //签约
      data.type = type  // type:1 签约 2:回款
      data.origin = 2
      window.localStorage.setItem('drillData', JSON.stringify(data))
      this.$router.push({ name: 'bsdrill' })
    },

    toSomeDrill(data, type) { //其他数据钻取
      data.type = type
      window.localStorage.setItem('drillData', JSON.stringify(data))
      this.$router.push({ name: 'drmdrill' })
    },

    getData(data) {
      this.$notice.loading()
      this.$http.getBusiness(data).then(res => { //主要数据
        this.data = res.data
      })

      this.$http.getPieChart(data).then(res => { //图表数据
        if (res.data.pieSaleTotalRate) {
          let pie1CircleArr = []
          res.data.pieSaleTotalRate.map(item => {
            pie1CircleArr.push(item.name)
          })
          this.pie1.legend.data = pie1CircleArr
        }
        this.pie1.series[0].data = res.data.pieSaleTotalRate
        this.pie1.title[1].text = (res.data.pieSaleTotal / 10000).toFixed(2)
        if (res.data.pieSaleBackRate) {
          let pie2CircleArr = []
          res.data.pieSaleBackRate.map(item => {
            pie2CircleArr.push(item.name)
          })
          this.pie2.legend.data = pie2CircleArr
        }

        this.pie2.series[0].data = res.data.pieSaleBackRate
        this.pie2.title[1].text = (res.data.pieSaleBack / 10000).toFixed(2)
        if (res.data.pieSaleCountRate) {
          let pie3CircleArr = []
          res.data.pieSaleCountRate.map(item => {
            pie3CircleArr.push(item.name)
          })
          this.pie3.legend.data = pie3CircleArr
        }

        this.pie3.series[0].data = res.data.pieSaleCountRate
        this.pie3.title[1].text = res.data.pieSaleCount

        this.$notice.loading(false)
      })

      this.$http.getBusinessAlert(data).then(res => { //预警数据
        this.alertData = res.data
      })

    } //获取数据
  },
  created() {
    if (!window.localStorage.getItem('drillData')) {
      
      this.begin_time = getMonthRanges().begin_time
      this.end_time = getMonthRanges().end_time
      this.slots = slotsList.Monthslots()
    } else {
      let data = JSON.parse(window.localStorage.getItem('drillData'))
      this.begin_time = data.begin_time
      this.end_time = data.end_time
      this.region = this.c_region = data.origin_region || data.region
      this.slots = slotsList.Monthslots(this.begin_time, this.end_time)
    }

    this.getData({ begin_time: this.begin_time, end_time: this.end_time, region: this.region })


  },

}
</script>

<style lang="css" scoped>
.container {
  width: 100%;
  background-color: #fafafa;
}
/*.container.filter{
      height: 100%;
      overflow: hidden;
    }*/
.header {
  width: 100%;
  background: #f5f5f5;
  padding-top: 0.15625rem;
  margin-bottom: 0.21875rem;
}
.select {
  width: 100%;
  color: #fff;
  height: 1.1875rem;
  background: #5483d2;
  font-size: 0.4375rem;
  line-height: 1.1875rem;
  padding-left: 0.34375rem;
  margin-bottom: 0.1875rem;
  position: relative;
}
.header .icon {
  font-size: 0.5rem;
  position: absolute;
  right: 0.5rem;
  top: 0;
  margin: auto;
}
.yes {
  background: #5483d2;
  color: #fff;
}
.top {
  width: 85%;
  border: 1px solid #5483d2;
  color: #737171;
  font-size: 0;
  margin: auto;
  border-radius: 0.09375rem;
  margin-bottom: 0.25rem;
}
.top p {
  font-size: 0.4375rem;
  display: inline-block;
  width: 33.3%;
  text-align: center;
  border-right: 1px solid #5483d2;
  padding: 0.125rem;
}
.top p:last-child {
  border: 0;
}
.data {
  width: 95%;
  margin: auto;
  color: #000;
  height: 6rem;
  border: 0;
  box-shadow: 0 0 5px #979797;
  border-radius: 0.25rem;
  background: #fff;
  margin-bottom: 0.25rem;
  padding-top: 0.75rem;
}
.data ul li {
  width: 88%;
  margin: auto;
  color: #333;
  font-size: 0.4375rem;
  margin-bottom: 0.75rem;
  font-family: PingFangSC-Regular;
  font-weight: 500;
}
.left {
  text-align: left;
  display: inline-block;
  width: 50%;
  float: left;
}
.right {
  text-align: right;
  display: inline-block;
  width: 50%;
}

.rank {
  color: #000;
  height: 8.6875rem;
  position: relative;
  width: 100%;
  background: #fff;
  margin-bottom: 0.375rem;
}
.percent1 {
  color: #000;
  height: 8.6875rem;
  position: relative;
  width: 100%;
  background: #fff;
  margin-bottom: 0.375rem;
}
.percent2 {
  color: #000;
  height: 8.6875rem;
  position: relative;
  width: 100%;
  background: #fff;
  margin-bottom: 0.375rem;
}
.test {
  border-left: 0.0625rem solid #5483d2;
  width: 100%;
  line-height: 1.5;
  font-size: 0.375rem;
  color: #333333;
  font-family: PingFangSC-Regular;
  padding-left: 2%;
  font-weight: 500;
}
.test span {
  position: absolute;
  right: 5%;
  font-family: PingFangSC-Regular;
  color: rgba(153, 153, 153, 1);
  font-size: 0.75rem;
}
.small {
  color: #333333;
  font-size: 0.375rem;
  display: inline-block;
}
.btn {
  border: 1px solid #5483d2;
  color: #5483d2;
  height: 0.75rem;
  line-height: 0.75rem;
  text-align: center;
  border-radius: 0.625rem;
  width: 5.4375rem;
  margin: auto;
  font-size: 0.4375rem;
}
.zhezhao {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 9;
  width: 100%;
  height: 100%;
}
.selbox {
  position: absolute;
  top: 0;
  right: 0;
  height: 100%;
  width: 7.0625rem;
  z-index: 99;
  background: #fff;
}
.selbox p:first-child {
  color: #999999;
  background: #f2f2f2;
  font-size: 0.375rem;
  height: 0.9375rem;
  line-height: 0.9375rem;
  padding-left: 0.46875rem;
}
.content {
  background: #fff;
  color: #333333;
  font-size: 0.4375rem;
  padding-left: 0.34375rem;
  padding-top: 0.1875rem;
}
.listtime {
  margin-top: 0.3125rem;
  margin-left: 0.1875rem;
}
.listtime li {
  width: 2.0625rem;
  text-align: center;
  height: 0.84375rem;
  line-height: 0.84375rem;
  border-radius: 0.125rem;
  background: #f1f1f1;
  color: #333333;
  display: inline-block;
  font-size: 0.375rem;
  margin-right: 0.1875rem;
  margin-bottom: 0.1875rem;
}
.listtime li:nth-child(3n) {
  margin-right: 0;
}
.true {
  color: #5483d2 !important;
  background: #c9ddfd !important;
}
.btnyes {
  height: 1.25rem;
  line-height: 1.25rem;
  background: #5483d2;
  position: absolute;
  width: 100%;
  bottom: 0;
  text-align: center;
  color: #fff;
  font-size: 0.4375rem;
}
</style>



// WEBPACK FOOTER //
// src/components/BusinessMon.vue